import { defineComponent as $, useAttrs as A, createBlock as k, openBlock as t, unref as o, withCtx as C, createElementVNode as i, mergeProps as y, createElementBlock as a, createCommentVNode as l, normalizeClass as s, renderSlot as r } from "vue";
import { RevListItemBase as w } from "@ds/components/ListItemBase";
const I = /* @__PURE__ */ $({
  name: "RevListItemStatic",
  inheritAttrs: !1,
  __name: "ListItemStatic",
  props: {
    wrapperAttrs: { default: () => ({}) },
    mainAreaClassNames: { type: [String, Boolean, Array, Object], default: "" }
  },
  setup(B) {
    const n = A();
    return (e, N) => (t(), k(o(w), { "wrapper-attrs": e.wrapperAttrs }, {
      default: C(({
        wrapperClassNames: p,
        prefixClassNames: m,
        descriptionClassNames: d,
        labelClassNames: f,
        suffixClassNames: u,
        mainAreaClassNames: c,
        titleClassNames: v
      }) => [
        i("div", y(o(n), { class: p }), [
          e.$slots.prefix ? (t(), a("div", {
            key: 0,
            class: s(m)
          }, [
            r(e.$slots, "prefix")
          ], 2)) : l("", !0),
          i("div", {
            class: s([c, e.mainAreaClassNames])
          }, [
            e.$slots.title ? (t(), a("div", {
              key: 0,
              class: s(v)
            }, [
              r(e.$slots, "title")
            ], 2)) : l("", !0),
            i("div", {
              class: s(["text-static-default-hi", f])
            }, [
              r(e.$slots, "label")
            ], 2),
            e.$slots.description ? (t(), a("div", {
              key: 1,
              class: s(d)
            }, [
              r(e.$slots, "description")
            ], 2)) : l("", !0)
          ], 2),
          e.$slots.suffix ? (t(), a("div", {
            key: 1,
            class: s(u)
          }, [
            r(e.$slots, "suffix")
          ], 2)) : l("", !0)
        ], 16)
      ]),
      _: 3
    }, 8, ["wrapper-attrs"]));
  }
});
export {
  I as default
};
